var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-list"},[(_vm.items.length <= 0)?_vm._t("items-empty-template"):_vm._e(),_vm._l((_vm.items),function(item,itemIndex){return _c('accordion-item',{key:itemIndex,attrs:{"expanded":itemIndex === 0,"item":item,"itemIndex":itemIndex,"showFooter":_vm.hasItemFooterTemplate},scopedSlots:_vm._u([{key:"item-header-template",fn:function(ref){
var item = ref.item;
var itemIndex = ref.itemIndex;
return [_vm._t("item-header-template",null,{"item":item,"itemIndex":itemIndex})]}},{key:"item-body-template",fn:function(ref){
var item = ref.item;
var itemIndex = ref.itemIndex;
return [_vm._t("item-body-template",null,{"item":item,"itemIndex":itemIndex})]}},{key:"item-footer-template",fn:function(ref){
var item = ref.item;
var itemIndex = ref.itemIndex;
return [_vm._t("item-footer-template",null,{"item":item,"itemIndex":itemIndex})]}}],null,true)})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }